
import axios from "axios"
import {notification} from "antd";
import {ACCESS_TOKEN, KEY_USER_INFO} from "@/Const";
import Global from "@/global";
import {APP_WEB_WWW} from "@/electron_interactive";
import {getCookies, isDevMode, isStringNullOrEmpty} from "@/utils";

// import cookie from 'react-cookies'
let mapErrCallback:any = {};

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: true?import.meta.env.VITE_DEV_HTTP_APP_BASE_URL:import.meta.env.VITE_HTTP_APP_BASE_URL,
  timeout: 60000 // 请求超时时间,
})

export const jsonParamToQueryString = (jsonParams:any)=>{
  var queryString:any = Object.keys(jsonParams)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(jsonParams[key]))
      .join('&');
  return queryString;
}


// export default request
//
// export {
//   request as axios,
//   appPostRequest,
//   appGetRequest,
//   appPutRequest,
//   appDeleteRequest,
//   switchAppBaseURL
// }

export const switchAppBaseURL =()=>{
  axios.defaults.baseURL = true?import.meta.env.VITE_DEV_HTTP_APP_BASE_URL:import.meta.env.VITE_HTTP_APP_BASE_URL;
}

export const appPostRequest = (url,data,callback)=>{
  mapErrCallback[url] = callback;
  return request({
    url:url,
    data:data,
    method:'post'
  })
}

export const appGetRequest = (url,data,callback)=>{
  mapErrCallback[url] = callback;
  return request({
    url:url,
    params:(data),
    method:'get'
  })
}

export const appPutRequest = (url,data,callback)=>{
  mapErrCallback[url] = callback;
  return request({
    url:url,
    data:data,
    method:'put'
  })
}

export const appDeleteRequest = (url,data,callback)=>{
  mapErrCallback[url] = callback;
  return request({
    url:url,
    data:data,
    method:'delete'
  })
}


// 异常拦截处理器
const errorHandler = (error:any) => {
  if (error.response) {
    const data = error.response.data

    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data
      })
    }

    if (error.response.status === 404) {
      if(mapErrCallback[error.response.config.url]){
        mapErrCallback[error.response.config.url](error);
      }
    }

    if (error.response.status === 401) {
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(KEY_USER_INFO);
      Global.g_userInfo = undefined;

      notification.error({
        message: data
      })
      if(mapErrCallback[error.response.config.url]){
        mapErrCallback[error.response.config.url]();
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  let token = localStorage.getItem(ACCESS_TOKEN)
  if (APP_WEB_WWW && isStringNullOrEmpty(token)){
    token = getCookies()['token'];
  }
  //test
  if (import.meta.env.DEV){
    token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMTQ6MTcyMjUyMzY2Njg4MSIsImV4cCI6MTcyMzM4NzY2Nn0.AhiN-0x32evoPWt8f2uC0DywSA4RVQV4dM_JkEjGvoMDmvOkD3ljYD4xqrF7yd2aZ3wYB5n5V6xTCtwnsDYhgw';
  }

  if (token) {
    config.headers['access_token'] = token
  }
  config.baseURL = true?import.meta.env.VITE_DEV_HTTP_APP_BASE_URL:import.meta.env.VITE_HTTP_APP_BASE_URL;
  return config;
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  return response.data
}, errorHandler)


